export const  SEARCH_PATTERN_REGEX = {
  PROPERTY_ID_REGEX: /\bproperty-id\b/,
  STATE_REGEX: /\bstate\b/,
  CITY_REGEX: /\bcity\b/,
  ZIP_CODE_REGEX: /\bzip\b/,
  NEIGHBORHOOD_NAME_REGEX: /\bneighborhood-name\b/,
  NEIGHBORHOOD_ID_REGEX: /\bneighborhood_id\b/,
  COUNTY_REGEX: /\bcounty\b/,
  APN_REGEX: /\bapn\b/,
};

